import React from 'react';
import { CtaButton } from './CtaButton';
import { keyFigures } from '../data/content';
export function ClosingCta() {
  return <section className="bg-navy-900 px-5 py-16 sm:py-20" data-id="element-30" data-mp="105ppv1t956as">
      <div className="mx-auto max-w-3xl text-center" data-id="element-31" data-mp="l7xbwe3cspyp">
        <h2 className="font-display text-3xl font-black leading-tight text-white sm:text-4xl" data-id="element-32" data-mp="l9i25rimxmqr">
          Deine nächste Einheit beginnt mit einem{' '}
          <span className="text-gold" data-id="element-33" data-mp="1dvt538tprzqq">klaren Plan.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-34" data-mp="1dyp3ey9h4qfp">
          Sechs Praxisbände für Kinder von 6 bis 12 Jahren – aufgebaut in drei
          Altersstufen, mit Varianten für unterschiedliche Lernstände.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-2" data-id="element-35" data-mp="194bbx6xxn3gb">
          {keyFigures.map(figure => <li key={figure.label} className="rounded-md border border-gold/30 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-gold" data-id="element-36" data-mp="1wt418kk1ud1y">
              {figure.value} {figure.label}
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-sm" data-id="element-37" data-mp="1f5r7gtpcc581">
          <CtaButton label="Die Bände ansehen" data-id="element-38" data-mp="1tsu46y5ua9ub" />
        </div>
      </div>
    </section>;
}